module.exports = __webpack_public_path__ + "img/huiyuanzhongxin_back.8d52fd8b.jpg";